import ViewInCandid from './ViewInCandid';

export { CandidLogo } from './CandidLogo';

export default ViewInCandid;
